// Class strings for the redesigned screens (Team, Settings): rounded-[14px]
// cards on gray-200 borders, 44px controls, one indigo primary per view.
//
// Destructive buttons follow one rule across the redesign:
//   - a list row gets `dangerIcon` (36px, icon only, outlined red);
//   - deleting the object a page is about gets `dangerOutline` (text + icon);
//   - solid red (`danger`) only on the confirming button inside a dialog.
export const buttonClass = {
  primary:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] bg-indigo-600 px-[18px] text-sm font-semibold text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50",
  secondary:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
  small:
    "inline-flex min-h-9 items-center justify-center rounded-lg border border-gray-300 bg-white px-3 text-[13px] font-medium whitespace-nowrap text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
  dangerIcon:
    "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-red-200 bg-white text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50",
  dangerOutline:
    "inline-flex min-h-10 items-center justify-center gap-1.5 rounded-lg border border-red-200 bg-white px-3.5 text-sm font-semibold text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50",
  danger:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] bg-red-700 px-[18px] text-sm font-semibold text-white hover:bg-red-800 disabled:cursor-not-allowed disabled:bg-red-300",
};

export const inputClass =
  "block min-h-11 w-full rounded-[10px] border border-gray-300 bg-white px-3 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-indigo-500";

export const labelClass =
  "flex flex-col gap-1.5 text-[13px] font-semibold text-gray-700";

export const cardClass = "rounded-[14px] border border-gray-200 bg-white";
